// extracted by mini-css-extract-plugin
export default {"hero":"hero_hero__8peu9","zoomOut":"hero_zoomOut__Oapie","heroContent":"hero_heroContent__DQc6E","fadeInUp":"hero_fadeInUp__jJO5H","heroBg":"hero_heroBg__-SdaM"};